import { z } from 'zod'
import { Filter } from 'domain/models/AttendeeSortField/AttendeeSortField'
import {
  AttendeeId,
  DraftOrderId,
  RaceId
} from 'domain/models/ValueObject/EntityIds'

export const WaitingListOrder = {
  REGISTRATION_DATE: 'REGISTRATION_DATE',
  RANDOM: 'RANDOM'
} as const

export type WaitingListOrder = keyof typeof WaitingListOrder

export interface WaitingListsRace {
  id: RaceId
  raceName: string
  displayOrder: number | null
  attendeesCount: number
  enabled: boolean
  delay?: number | null
  order?: WaitingListOrder | null
  autoRelease?: boolean | null
}

export const WaitingListsRaceSchema = z.object({
  id: z.number(),
  delay: z.coerce.number().positive(),
  order: z.enum([WaitingListOrder.REGISTRATION_DATE, WaitingListOrder.RANDOM]),
  autoRelease: z.boolean()
})

export type WaitingListsRaceSchema = z.infer<typeof WaitingListsRaceSchema>

export const WaitingListAttendeeSchema = (isRelay: boolean) =>
  z.object({
    lastName: z.string().min(1),
    firstName: z.string().min(1),
    email: z.string().min(1).email(),
    relayTeamName: isRelay ? z.string().min(1) : z.string().optional()
  })

export type WaitingListAttendee = z.infer<
  ReturnType<typeof WaitingListAttendeeSchema>
>
export enum ColumnField {
  CREATED_AT = 'createdAt',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  EMAIL = 'email',
  TEAM_NAME = 'relayTeamName'
}

export interface GetAwaitingAttendeesParams {
  raceId: RaceId
  searchQuery?: string | undefined
  sortField: ColumnField | string
  sortDirection: 'asc' | 'desc'
  start: number
  end: number
  filter?: Filter
}

export interface AwaitingAttendee extends WaitingListAttendee {
  id: AttendeeId
  createdAt: Date
  draftOrderId: DraftOrderId | null
}

export type AttendeeToRelease = Omit<AwaitingAttendee, 'draftOrderId'>

export interface GetWithFiltersResponse {
  attendees: AwaitingAttendee[]
  count: number
}
